import { render, staticRenderFns } from "./TLDview.vue?vue&type=template&id=6bb39a82&lang=pug&"
import script from "./TLDview.vue?vue&type=script&lang=js&"
export * from "./TLDview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports